import { formatDateTime } from '@dashboard/lib/format-date';

const DEFAULT_MAX = 5;

const STOPPED = {
  complete: 'All attendees added',
  event_started: 'Event started',
  canceled: 'Booking canceled',
  off: 'Reminders off for this event',
};

export default function guestReminderText(reminders) {
  if (!reminders) return null;
  const { sentCount = 0, maxCount = DEFAULT_MAX, stoppedReason } = reminders;
  const sent = `${sentCount} of ${maxCount}`;
  if (stoppedReason === 'limit') return `${maxCount} of ${maxCount}`;
  if (!stoppedReason) return sent;
  const why = STOPPED[stoppedReason] ?? 'Reminders stopped';
  return sentCount > 0 ? `${sent}. ${why}` : why;
}

export function nextReminderText(reminders, now = new Date()) {
  if (!reminders || reminders.stoppedReason) return null;
  // The API leaves nextSendAt empty when the next one would land at or after the event start.
  if (!reminders.nextSendAt) return 'None before the event';
  const next = new Date(reminders.nextSendAt);
  return next <= now ? 'Soon' : formatDateTime(next);
}

export const guestReminderRows = (reminders, now = new Date()) => {
  if (!reminders) return [];
  const next = nextReminderText(reminders, now);
  return [
    { label: 'Reminders sent', value: guestReminderText(reminders), copy: null },
    ...(reminders.sentCount > 0 && reminders.lastSentAt
      ? [{ label: 'Last sent', value: formatDateTime(reminders.lastSentAt), copy: null }]
      : []),
    ...(next ? [{ label: 'Next reminder', value: next, copy: null }] : []),
  ];
};
